module.exports = __webpack_public_path__ + "img/home.1c80c24b.svg";